import React from "react";
import ResetFilters from "../ResetFilters";
import styles from "./noResultsFound.module.scss";
const EmptyState = ({ subject, filters, hint, }) => {
    if (filters === null || filters === void 0 ? void 0 : filters.active) {
        return (React.createElement("div", { className: styles.content },
            React.createElement("span", { className: styles.title }, `No ${subject} matching your filters`),
            React.createElement("span", { className: styles.hint }, "Try widening the search or removing a filter."),
            React.createElement(ResetFilters, { onClick: filters.onReset })));
    }
    return (React.createElement("div", { className: styles.content },
        React.createElement("span", { className: styles.title }, `No ${subject} yet`),
        hint && React.createElement("span", { className: styles.hint }, hint)));
};
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map